export const formatMoney = (value: number | null | undefined): string =>
  new Intl.NumberFormat("pl-PL", {
    style: "currency",
    currency: "PLN",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value ?? 0);

// Pełna precyzja (do 8 miejsc po przecinku) — np. tabela budżetu zadania, gdzie
// kwoty paragrafów mogą mieć rozszerzoną dokładność.
export const formatMoneyPrecise = (value: number | null | undefined): string =>
  new Intl.NumberFormat("pl-PL", {
    style: "currency",
    currency: "PLN",
    minimumFractionDigits: 2,
    maximumFractionDigits: 8,
  }).format(value ?? 0);
